// extracted by mini-css-extract-plugin
export default {"container":"applicants-filter_container__I7Rvn","searchWrapper":"applicants-filter_searchWrapper__OFR6E"};